/* eslint-disable no-param-reassign */
import { ApiResourcesFactory } from '@/api/api-resources-factory';
import { apiRequestFactory } from '@/api/api-requests-factory';
import { useAuth } from '@/store/auth.store';
import { storeToRefs } from 'pinia';
import { authErrorCodes } from '@/models/auth/auth.model';
import { notifyErrorOnce } from '@marfa/bo-utils';
import { showErrorNotification } from '@/utils/show-notification.util';

export const apiResourcesFactory = new ApiResourcesFactory();
export const http = apiRequestFactory.getRequestPerformer();

http.setInterceptor({
  request: {
    onFulfilled(config) {
      const { token } = storeToRefs(useAuth());

      if (!config.headers) {
        config.headers = {};
      }

      if (token.value) {
        config.headers['X-Auth-Token'] = token.value;
      }

      return config;
    },
  },
  response: {
    onFulfilled(response) {
      const fileContentTypes = ['text/csv; charset=UTF-8'];

      if (fileContentTypes.includes(response.headers['content-type'])) {
        response.data = { fileData: response.data };
      }

      if (response.data.textCode) {
        const error = new Error(response.data.message);

        notifyErrorOnce(error, () => {
          showErrorNotification(error);
        });

        throw error;
      }

      return response;
    },
    onRejected(error) {
      notifyErrorOnce(error, () => {
        showErrorNotification(error);
      });

      if (authErrorCodes.includes(error.response?.status)) {
        const { setToken } = useAuth();

        setToken('');
      }

      throw error;
    },
  },
});

export const api = apiResourcesFactory.getInstance(http);
